import React, { useState, useEffect, useRef } from 'react';

// LocationButton Component
const LocationButton = ({ visible, type, clickaction }) => {
  const activeClass = visible ? "" : "is-hidden";
  
  const onClick = (e) => {
    e.preventDefault();
    clickaction();
  };

  return (
    <div className={`geo-form-location-button ${activeClass}`}>
      <button className="pure-button" onClick={onClick}>
        {type}
      </button>
    </div>
  );
};

// LocationMap Component
const LocationMap = ({ center, type, mapController }) => {
  const [state, setState] = useState(() => {
    let lat = center[0];
    let lng = center[1];

    if (!lat || !lng || isNaN(parseFloat(lat)) || isNaN(parseFloat(lng))) {
      lat = 39.8283;
      lng = -98.5795;
      console.log("Using default coordinates for map:", lat, lng);
    } else {
      lat = parseFloat(lat);
      lng = parseFloat(lng);
    }

    return {
      lat: lat,
      lng: lng,
      resetable: false,
    };
  });

  const geoidRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      initMap();
    }, 500);

    return () => {
      clearTimeout(timer);
      if (geoidRef.current) {
        geoidRef.current.unbind("geocode:result");
        geoidRef.current.unbind("geocode:dragged");
      }
    };
  }, []);

  const initMap = () => {
    const mapCanvas = document.getElementById("mylocationmapcanvas");
    if (!mapCanvas) {
      console.error("Map canvas element not found, cannot initialize geocomplete");
      return;
    }

    geoidRef.current = $("#geocomplete");
    console.log("jQuery element:", geoidRef.current);
    console.log("geocomplete function available:", typeof geoidRef.current.geocomplete);
    
    setupMap();
    setupDraggable();
    setLocationString(false);
    setupLatLng();
  };

  const setupMap = () => {
    setTimeout(() => {
      try {
        // Check if Google Maps and geocomplete are available
        if (typeof google === 'undefined' || !google.maps) {
          console.error("Google Maps API not loaded");
          return;
        }
        
        if (typeof geoidRef.current.geocomplete !== 'function') {
          console.error("geocomplete plugin not available");
          return;
        }

        const validLocation = [state.lat, state.lng];
        console.log("Initializing map with coordinates:", validLocation);

        geoidRef.current.geocomplete({
          map: "#mylocationmapcanvas",
          details: "form",
          location: validLocation,
          detailsAttribute: "data-geo",
          mapOptions: {
            zoom: 5,
            minZoom: 2,
            maxZoom: 18,
            zoomControl: true,
            zoomControlOptions: {
              style: google.maps.ZoomControlStyle.LARGE,
            },
          },
          markerOptions: {
            draggable: true,
          },
          types: ["geocode"],
        });

        setTimeout(() => {
          const map = geoidRef.current.geocomplete("map");
          if (map) {
            google.maps.event.trigger(map, "resize");
          }
        }, 200);
      } catch (e) {
        console.error("Error initializing geocomplete:", e);
      }
    }, 100);
  };

  const findClick = () => {
    setLocationString(true);
  };

  const resetClick = () => {
    geoidRef.current.geocomplete("resetMarker", resetState());
  };

  const resetState = () => {
    setState(prevState => ({ ...prevState, resetable: false }));
  };

  const setLocationString = (click) => {
    const street = $("#street_address").val();
    const locality = $("#locality").val();
    const stateVal = $("#state").val();
    const zip = $("#postal_code").val();
    
    console.log("Address fields:", { street, locality, stateVal, zip });
    
    setState(prevState => ({ ...prevState, full_address: [street, locality, stateVal, zip] }));
    if (click) {
      setNewLocation([street, locality, stateVal, zip]);
    }
  };

  const setNewLocation = (full_address) => {
    console.log("Setting new location:", full_address);
    const addressString = full_address.filter(part => part && part.trim()).join(", ");
    console.log("Address string:", addressString);
    
    if (!addressString) {
      alert("Please fill in the address fields first (Street, City, State, ZIP)");
      return;
    }
    
    geoidRef.current.val(addressString);
    geocode();
  };

  const setupLatLng = () => {
    geoidRef.current.bind("geocode:result", (event, latLng) => {
      setState(prevState => ({
        ...prevState,
        lat: latLng.geometry.location.lat(),
        lng: latLng.geometry.location.lng(),
      }));
    });
  };

  const geocode = () => {
    geoidRef.current.trigger("geocode");
  };

  const setupDraggable = () => {
    geoidRef.current.bind("geocode:dragged", (event, latLng) => {
      setState(prevState => ({
        ...prevState,
        resetable: true,
        lat: latLng.lat(),
        lng: latLng.lng(),
      }));
    });
  };

  return (
    <div className="admin-geo-complete">
      <div className="control-group">
        <div className="controls">
          <input
            id="geocomplete"
            name="geo-lookup"
            type="hidden"
            placeholder="Enter a location"
            autoComplete="off"
          />
          <LocationButton
            visible={true}
            type="Find this location on the map"
            clickaction={findClick}
          />
          <input
            id="initial-location"
            type="hidden"
            value={mapController.state.initialLocation}
          />
          <p>
            This is how people will find you on the map - it is crucial for being discovered, so make sure your location is correct.
          </p>
          <p>
            You can drag and drop the pin to adjust your location, if needed.
          </p>
        </div>
      </div>
      <div className="input float optional tribe_location_lat">
        <input
          className="numeric float optional span4 google-maps-query-data hidden"
          data-geo="lat"
          type="number"
          step="any"
          value={state.lat}
          name={`${type}[location_attributes][lat]`}
          id="tribe_location_attributes_lat"
          readOnly
        />
      </div>
      <div className="input float optional tribe_location_lng">
        <input
          className="numeric float optional span4 google-maps-query-data hidden"
          data-geo="lng"
          type="number"
          step="any"
          value={state.lng}
          name={`${type}[location_attributes][lng]`}
          id="tribe_location_attributes_lng"
          readOnly
        />
      </div>
      <LocationButton
        visible={state.resetable}
        type="Reset"
        clickaction={resetClick}
      />
      <div
        id="mylocationmapcanvas"
        style={{
          height: "400px",
          width: "100%",
          marginBottom: "20px",
        }}
      />
    </div>
  );
};

// AreaToolButton Component
const AreaToolButton = ({ reactMap }) => {
  const [state, setState] = useState({
    edit: false,
    draw: true,
  });

  const drawClick = (e) => {
    e.preventDefault();
    if (state.draw === false) {
      setState({ edit: false, draw: true });
      reactMap.startDrawing();
    }
  };

  const editClick = (e) => {
    e.preventDefault();
    if (state.edit === false) {
      setState({ edit: true, draw: false });
      reactMap.startEditing();
    }
  };

  const drawClass = state.draw ? "is-active " : "";
  const editClass = state.edit ? "is-active " : "";

  return (
    <div>
      <button
        onClick={drawClick}
        className={`${drawClass}esri-tool-button pure-button`}
      >
        Draw
      </button>
      <button
        onClick={editClick}
        className={`${editClass}esri-tool-button pure-button`}
      >
        Edit
      </button>
    </div>
  );
};

// AreaDeleteButton Component
const AreaDeleteButton = ({ visible, reactMap, polygon }) => {
  const deleteArea = (e) => {
    e.preventDefault();
    reactMap.removePolygon(polygon);
  };

  const visibleClass = visible ? "is-visable " : "";

  return (
    <div>
      <button
        onClick={deleteArea}
        className={`${visibleClass}esri-tool-button esri-delete-button pure-button`}
      >
        Delete Area
      </button>
    </div>
  );
};

// AreaMap Component
const AreaMap = ({ center, areapaths }) => {
  const [state, setState] = useState({
    paths: getPaths(),
  });

  const esriMapRef = useRef(null);

  function getPaths() {
    return areapaths.map((areaObj) => ({
      id: areaObj.id,
      path: areaObj.path,
    }));
  }

  useEffect(() => {
    createMap();
  }, []);

  const startDrawing = () => {
    setState(prevState => ({ ...prevState, drawable: true, editable: false, deletable: false }));
    esriMapRef.current.deactivateEditable();
    esriMapRef.current.activateDrawable();
  };

  const areaDeletable = (clickEvt) => {
    if (state.editable) {
      setState(prevState => ({ ...prevState, deletable: true, areaToDelete: clickEvt.graphic }));
    }
  };

  const startEditing = () => {
    setState(prevState => ({ ...prevState, drawable: false, editable: true }));
    esriMapRef.current.deactivateDrawable();
    esriMapRef.current.activateEditable();
  };

  const removePolygon = (polygon) => {
    esriMapRef.current.removePolygon(polygon);
  };

  const createMap = () => {
    // Esri map initialization will be handled at runtime when Esri modules are available
    console.log("AreaMap createMap called - Esri integration pending");
    
    // TODO: Implement Esri map initialization when modules are loaded from CDN
    // This requires the Esri JavaScript API to be loaded via script tag in the HTML
  };

  const pathfieldnameid = state.paths.map((i, index) => [
    `tribe[areas_attributes][${index}][path]`,
    `tribe_areas_attributes_${index}_path`,
  ]);

  const idfieldnameid = state.paths.map((i, index) => {
    const fieldName = `tribe[areas_attributes][${index}][id]`;
    const fieldId = `tribe_areas_attributes_${index}_id`;
    if (i.id) {
      return (
        <input
          key={`areaid-${index}`}
          className="hidden"
          type="text"
          value={i.id}
          name={fieldName}
          id={fieldId}
        />
      );
    }
    return null;
  });

  const paths = state.paths.map((i) => {
    if (Array.isArray(i.path)) {
      i.path = JSON.stringify(i.path);
    }
    return i.path;
  });

  const pathfields = state.paths.map((i, index) => (
    <div key={`pathfield-${index}`}>
      <div className="input text optional tribe_areas_path">
        <textarea
          value={paths[index]}
          className="hidden text optional pure-control-group"
          name={pathfieldnameid[index][0]}
          id={pathfieldnameid[index][1]}
        />
      </div>
      {idfieldnameid[index]}
    </div>
  ));

  return (
    <div>
      <h3>Tribal Lands Boundary</h3>
      <p>
        Optional. This will put your tribe's land onto the interactive map. If this is blank, your tribe will be represented as a circle.
      </p>
      <p>
        Click to draw the points of a shape. Double-click to end and close the shape.
      </p>
      <AreaToolButton reactMap={{ startDrawing, startEditing }} />
      <div
        id="areamapcanvas"
        style={{
          height: "400px",
          width: "100%",
          marginBottom: "20px",
        }}
      />
      {pathfields}
    </div>
  );
};

// Main GeoForms Component
const GeoForms = ({ initialLocation, drawingmgr = false, areapaths = [], type }) => {
  const [state, setState] = useState({
    center: extractInitialLocation(initialLocation),
    initialLocation: initialLocation,
  });

  function extractInitialLocation(initialLocation) {
    const location_array = initialLocation.split(",");
    const format = location_array[0];

    const defaultLat = 39.8283;
    const defaultLng = -98.5795;

    if (format === "latlng" && location_array.length >= 3) {
      const lat = parseFloat(location_array[1]);
      const lng = parseFloat(location_array[2]);

      if (!isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
        return [lat, lng];
      }
    }

    console.log(
      "Using default coordinates due to invalid or incomplete location data:",
      format
    );
    return [defaultLat, defaultLng];
  }

  const recenterAreaMap = () => {
    // TODO center area map when location map is dragged, reset, or geocoded.
  };

  let maps;
  if (drawingmgr === true) {
    maps = (
      <div>
        <LocationMap
          mapController={{ state }}
          center={state.center}
          type={type}
        />
        <AreaMap
          mapController={{ state }}
          center={state.center}
          areapaths={areapaths}
        />
      </div>
    );
  } else {
    maps = (
      <div>
        <LocationMap
          mapController={{ state }}
          center={state.center}
          type={type}
        />
      </div>
    );
  }

  return maps;
};

export default GeoForms;